import React from "react"
import { HStack, Text } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import Link from "components/elements/Link"
import CopyIconButton from "components/elements/CopyIconButton"

export const linkPrefixStyle = {
  bg: "gray.50",
  fontFamily: "mono",
  fontSize: "sm",
  borderColor: "gray.300",
  color: "gray.600",
  px: 3,
  whiteSpace: "nowrap",
} as const

export const LinkPrefixText = ({ url }: { url?: string }) => {
  const { protocol, host } = new URL(url || window.location.origin)

  return (
    <>
      {`${protocol}//`}
      <Text as="span" color="gray.900" fontWeight="semibold">{host}</Text>
      /
    </>
  )
}

export const LinkActions = ({ url }: { url: string }) => (
  <HStack spacing={0} flexShrink={0}>
    <Link href={url} isExternal aria-label="Open" title="Open" p={1.5} color="gray.600" _hover={{ color: "gray.900" }}>
      <Icon icon="link-external" size={4} />
    </Link>
    <CopyIconButton text={url} />
  </HStack>
)

export const UrlText = ({ url, slug }: { url: string, slug?: string | null }) => {
  const { protocol, host, pathname } = new URL(url)
  const [, first, ...rest] = pathname.split("/")
  const path = first === slug ? rest.join("/") : [first, ...rest].join("/")

  return (
    <Text as="span" fontFamily="mono" fontSize="sm" noOfLines={1} wordBreak="break-all">
      {`${protocol}//${host}/`}
      {first === slug && (
        <Text as="span" color="blue.500" fontWeight="semibold">{slug}</Text>
      )}
      {path && (
        <Text as="span" fontWeight="semibold">{first === slug ? `/${path}` : path}</Text>
      )}
    </Text>
  )
}
